export enum UploadedFileType {
    Image = 'Image',
    PDF = 'PDF',
    EML = 'EML',
    Other = 'Other',
    Video = 'Video',
}
